module.exports = __webpack_public_path__ + "img/book.4965fa31.svg";